import { Controller } from '@hotwired/stimulus'
import { t } from '@lingui/core/macro'
import * as echarts from 'echarts'
import { optionsForChart } from '~/components/echarts/options'
import { csrfHeader } from '~/utils/csrf'

export default class EChartsController extends Controller {
  static targets = ['chart', 'maximizeButton', 'maximizeIcon', 'minimizeIcon']
  static values = {
    option: Object,
    url: String,
  }

  async connect() {
    const echart = echarts.init(this.chartTarget, null, {
      width: 'auto',
      height: 'auto',
    })

    if (this.hasUrlValue) {
      try {
        const response = await fetch(this.urlValue, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...csrfHeader(),
          },
        })
        const data = await response.json()
        const options = optionsForChart(data)
        echart.setOption(options)
      } catch (error) {
        console.error('Error fetching chart data:', error)
      }
    } else if (this.hasOptionValue) {
      echart.setOption(this.optionValue)
    }

    const resizeObserver = new ResizeObserver(() => echart.resize())
    resizeObserver.observe(this.chartTarget)
    resizeObserver.observe(document.querySelector('body'))
    this.echart = echart
    this.resizeObserver = resizeObserver
  }

  disconnect() {
    this.echart.dispose()
    this.resizeObserver.disconnect()
  }

  toggleMaximize() {
    const maximized = this.element.classList.toggle('chart-maximized')
    document.body.classList.toggle('chart-maximized-active', maximized)

    this.maximizeIconTarget.classList.toggle('d-none', maximized)
    this.minimizeIconTarget.classList.toggle('d-none', !maximized)
    this.maximizeButtonTarget.title = maximized ? t`Restore` : t`Maximize`

    if (maximized) {
      this.originalChartHeight = this.chartTarget.style.height
      this.chartTarget.style.height = '100%'
    } else {
      this.chartTarget.style.height = this.originalChartHeight
    }

    requestAnimationFrame(() => this.echart.resize())
  }
}
